import React from 'react';
import { Toolbar } from 'react-admin';


const SaveOnlyToolbar = ({ record, ...rest }) => (
  // Removing the `record` prop prevents the DeleteButton from being included
  // https://github.com/marmelab/react-admin/blob/f1222cb34b16cd32d21e08ca7364ace8118b38b2/packages/ra-ui-materialui/src/form/Toolbar.js#L94-L101
  <Toolbar {...rest} />
);


export default SaveOnlyToolbar;



// WEBPACK FOOTER //
// ./src/components/SaveOnlyToolbar.js